/**
 * CatcSoft DS icons — port directo de design-system/sar/icons.jsx.
 * Lucide-style: stroke 1.6, currentColor, 24x24. Todos los SVG inline,
 * cero dependencias externas.
 */

import type { ReactNode, SVGProps } from "react";

interface IProps extends Omit<SVGProps<SVGSVGElement>, "children"> {
  children: ReactNode;
  viewBox?: string;
}

function I({ children, viewBox = "0 0 24 24", ...rest }: IProps) {
  return (
    <svg
      viewBox={viewBox}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...rest}
    >
      {children}
    </svg>
  );
}

export const IconGauge = () => (
  <I>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" />
    <path d="m13.4 10.6 4-4" />
  </I>
);
export const IconFolder = () => (
  <I>
    <path d="M4 7a2 2 0 0 1 2-2h3.5l2 2H18a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7Z" />
  </I>
);
export const IconGit = () => (
  <I>
    <circle cx="6" cy="6" r="2" />
    <circle cx="18" cy="6" r="2" />
    <circle cx="12" cy="18" r="2" />
    <path d="M6 8v6a2 2 0 0 0 2 2h2" />
    <path d="M18 8v2a4 4 0 0 1-4 4h-2" />
  </I>
);
export const IconCheck = () => (
  <I>
    <path d="M5 12.5 10 17l9-10" />
  </I>
);
export const IconX = () => (
  <I>
    <path d="m6 6 12 12M18 6 6 18" />
  </I>
);
export const IconChevR = () => (
  <I>
    <path d="m9 6 6 6-6 6" />
  </I>
);
export const IconChevD = () => (
  <I>
    <path d="m6 9 6 6 6-6" />
  </I>
);
export const IconChevL = () => (
  <I>
    <path d="m15 6-6 6 6 6" />
  </I>
);
export const IconPlay = () => (
  <I>
    <path d="M7 5v14l12-7L7 5Z" fill="currentColor" />
  </I>
);
export const IconRefresh = () => (
  <I>
    <path d="M3 12a9 9 0 0 1 15-6.7L21 8" />
    <path d="M21 3v5h-5" />
    <path d="M21 12a9 9 0 0 1-15 6.7L3 16" />
    <path d="M3 21v-5h5" />
  </I>
);
export const IconPlus = () => (
  <I>
    <path d="M12 5v14M5 12h14" />
  </I>
);
export const IconSearch = () => (
  <I>
    <circle cx="11" cy="11" r="7" />
    <path d="m20 20-3.5-3.5" />
  </I>
);
export const IconBell = () => (
  <I>
    <path d="M6 8a6 6 0 0 1 12 0c0 6 3 7 3 9H3c0-2 3-3 3-9Z" />
    <path d="M10 21a2 2 0 0 0 4 0" />
  </I>
);
export const IconUser = () => (
  <I>
    <circle cx="12" cy="8" r="4" />
    <path d="M4 20a8 8 0 0 1 16 0" />
  </I>
);
export const IconUsers = () => (
  <I>
    <circle cx="9" cy="8" r="3.5" />
    <path d="M2 20a7 7 0 0 1 14 0" />
    <circle cx="17" cy="9" r="2.5" />
    <path d="M16 20a5 5 0 0 1 6-5" />
  </I>
);
export const IconShield = () => (
  <I>
    <path d="M12 3 4 6v6c0 5 3.5 8 8 9 4.5-1 8-4 8-9V6l-8-3Z" />
    <path d="m9 12 2 2 4-4" />
  </I>
);
export const IconCpu = () => (
  <I>
    <rect x="5" y="5" width="14" height="14" rx="2" />
    <rect x="9" y="9" width="6" height="6" rx="1" />
    <path d="M9 1v3M15 1v3M9 20v3M15 20v3M1 9h3M1 15h3M20 9h3M20 15h3" />
  </I>
);
export const IconStack = () => (
  <I>
    <path d="m12 4 9 5-9 5-9-5 9-5Z" />
    <path d="m3 14 9 5 9-5" />
    <path d="m3 19 9 5 9-5" />
  </I>
);
export const IconReports = () => (
  <I>
    <path d="M4 4h16v16H4z" />
    <path d="M8 16V10M12 16V6M16 16v-4" />
  </I>
);
export const IconBolt = () => (
  <I>
    <path d="M13 3 5 14h6l-2 7 8-11h-6l2-7Z" />
  </I>
);
export const IconKey = () => (
  <I>
    <circle cx="8" cy="14" r="4" />
    <path d="m11 11 9-9M16 6l3 3M14 8l3 3" />
  </I>
);
export const IconCalendar = () => (
  <I>
    <rect x="3" y="5" width="18" height="16" rx="2" />
    <path d="M3 9h18M8 3v4M16 3v4" />
  </I>
);
export const IconClock = () => (
  <I>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 2" />
  </I>
);
export const IconSliders = () => (
  <I>
    <path d="M4 21v-7M4 10V3M12 21v-9M12 8V3M20 21v-5M20 12V3" />
    <circle cx="4" cy="12" r="2" />
    <circle cx="12" cy="10" r="2" />
    <circle cx="20" cy="14" r="2" />
  </I>
);
export const IconLogout = () => (
  <I>
    <path d="M15 16v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v3" />
    <path d="M21 12H9m12 0-3-3m3 3-3 3" />
  </I>
);
export const IconLogin = () => (
  <I>
    <path d="M9 8V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-3" />
    <path d="M3 12h12m0 0-3-3m3 3-3 3" />
  </I>
);
export const IconMoon = () => (
  <I>
    <path d="M21 13A9 9 0 1 1 11 3a7 7 0 0 0 10 10Z" />
  </I>
);
export const IconSun = () => (
  <I>
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v3M12 19v3M2 12h3M19 12h3M5 5l2 2M17 17l2 2M5 19l2-2M17 7l2-2" />
  </I>
);
export const IconLayers = () => (
  <I>
    <path d="m12 3 9 5-9 5-9-5 9-5Z" />
    <path d="m3 13 9 5 9-5" />
  </I>
);
export const IconCopy = () => (
  <I>
    <rect x="9" y="9" width="11" height="11" rx="2" />
    <path d="M5 15V5a2 2 0 0 1 2-2h10" />
  </I>
);
export const IconExternal = () => (
  <I>
    <path d="M14 4h6v6" />
    <path d="M10 14 20 4" />
    <path d="M19 13v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h5" />
  </I>
);
export const IconDot = () => (
  <I>
    <circle cx="12" cy="12" r="3" fill="currentColor" />
  </I>
);
export const IconAlert = () => (
  <I>
    <path d="M12 3 2 20h20L12 3Z" />
    <path d="M12 10v5M12 18v.5" />
  </I>
);
export const IconTerminal = () => (
  <I>
    <path d="m4 7 5 5-5 5" />
    <path d="M12 19h8" />
    <rect x="2" y="3" width="20" height="18" rx="2" fill="none" />
  </I>
);
export const IconFlag = () => (
  <I>
    <path d="M5 21V4" />
    <path d="M5 4h11l-2 4 2 4H5" />
  </I>
);
export const IconLink = () => (
  <I>
    <path d="M10 14a4 4 0 0 0 6 0l3-3a4 4 0 0 0-6-6l-1 1" />
    <path d="M14 10a4 4 0 0 0-6 0l-3 3a4 4 0 0 0 6 6l1-1" />
  </I>
);
export const IconCircle = () => (
  <I>
    <circle cx="12" cy="12" r="9" />
  </I>
);
export const IconBox = () => (
  <I>
    <path d="M21 8 12 3 3 8v8l9 5 9-5V8Z" />
    <path d="m3 8 9 5 9-5M12 13v8" />
  </I>
);
export const IconFilter = () => (
  <I>
    <path d="M3 5h18l-7 9v6l-4-2v-4L3 5Z" />
  </I>
);
export const IconDownload = () => (
  <I>
    <path d="M12 4v12m0 0-4-4m4 4 4-4" />
    <path d="M4 20h16" />
  </I>
);
export const IconUpload = () => (
  <I>
    <path d="M12 20V8m0 0-4 4m4-4 4 4" />
    <path d="M4 4h16" />
  </I>
);
export const IconMore = () => (
  <I>
    <circle cx="6" cy="12" r="1.3" fill="currentColor" />
    <circle cx="12" cy="12" r="1.3" fill="currentColor" />
    <circle cx="18" cy="12" r="1.3" fill="currentColor" />
  </I>
);
export const IconEdit = () => (
  <I>
    <path d="M12 20h9" />
    <path d="M16.5 3.5a2.1 2.1 0 1 1 3 3L7 19l-4 1 1-4 12.5-12.5Z" />
  </I>
);
export const IconTrash = () => (
  <I>
    <path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M6 6l1 14a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-14" />
  </I>
);
export const IconLock = () => (
  <I>
    <rect x="4" y="11" width="16" height="10" rx="2" />
    <path d="M8 11V7a4 4 0 0 1 8 0v4" />
  </I>
);
export const IconEye = () => (
  <I>
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8S1 12 1 12Z" />
    <circle cx="12" cy="12" r="3" />
  </I>
);
export const IconHome = () => (
  <I>
    <path d="M3 11 12 3l9 8" />
    <path d="M5 10v10h14V10" />
  </I>
);
export const IconHash = () => (
  <I>
    <path d="M4 9h16M4 15h16M10 3 8 21M16 3l-2 18" />
  </I>
);
export const IconArrow = () => (
  <I>
    <path d="M5 12h14m0 0-5-5m5 5-5 5" />
  </I>
);
